var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_11009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8a2.667 2.667 0 100-5.333A2.667 2.667 0 008 8zm0-4a1.333 1.333 0 110 2.667A1.333 1.333 0 018 4zm5.773 2.105l-.48-.16A5.335 5.335 0 008 0a5.329 5.329 0 00-5.276 6.061 3.363 3.363 0 00-1.698.867A3.297 3.297 0 00-.001 9.333v2.717a3.342 3.342 0 002.4 3.2l1.914.6a3.332 3.332 0 001.896.026l3.853-1.14a1.991 1.991 0 011.049 0l1.59.533A2.666 2.666 0 0016 12.681V9.248a3.343 3.343 0 00-2.226-3.144zM5.17 2.508a3.991 3.991 0 015.656 0 4.025 4.025 0 01.008 5.667l-2.37 2.303a.661.661 0 01-.925 0L5.17 8.185a4.027 4.027 0 010-5.677zm9.495 10.173a1.327 1.327 0 01-.51 1.048 1.312 1.312 0 01-1.084.263l-1.563-.525a3.349 3.349 0 00-1.811-.011l-3.856 1.139a2 2 0 01-1.13-.02l-1.929-.6a2.009 2.009 0 01-1.45-1.925V9.333a1.976 1.976 0 01.613-1.442c.305-.29.695-.479 1.113-.537a5.347 5.347 0 001.176 1.78l2.378 2.301a1.988 1.988 0 002.783 0l2.375-2.308a5.31 5.31 0 001.209-1.881l.358.119a2.004 2.004 0 011.328 1.883v3.433z",
    fill: "#5A6366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_11009"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.7cd326d66ad98a5140e7ce0b89866ae5.svg";
export { ForwardRef as ReactComponent };